import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import axios from "axios";
import {
  Section,
  SectionTitle,
  Card,
  NoteCard,
  FormGrid,
  FormSection,
  SectionHeader,
  FieldGroup,
  Field,
  Label,
  Input,
  Textarea,
  Helper,
  FieldHelper,
  Error,
  Actions,
  PrimaryButton,
  FormError,
  Banner,
  ProcessSuccessContainer,
  ProcessFailedContainer,
  ConfirmationCard,
  ConditionalAlert,
  SelectStyled
} from "../styles/StyledComponents";
import ServiceTransferBanner from "./ServiceTransferBanner";

/* -------------------- Mounted Guard Hook -------------------- */
function useIsMounted() {
  const ref = React.useRef(false);
  useEffect(() => {
    ref.current = true;
    return () => { ref.current = false; };
  }, []);
  return ref;
}

const SubmitComplaint = () => {
  const history = useHistory();

  const [docData, setDocData] = useState({ login: false, valid: false });
  const [showPDF, setShowPDF] = useState(false);
  const [processStatus, setProcessStatus] = useState(false);

  const [invoiceId, setinvoiceId] = useState("");
  const [invoiceIderror, setinvoiceIderror] = useState("");
  const [nId, setnId] = useState("");
  const [nIderror, setnIderror] = useState("");
  const [requestId, setrequestId] = useState("");
  const [studentName, setstudentName] = useState("");
  const [studentNameerror, setstudentNameerror] = useState("");
  const [schoolName, setschoolName] = useState("");
  const [schoolNameerror, setschoolNameerror] = useState("");
  const [disabled, setDisabled] = useState(false);

  const [subject, setsubject] = useState("");
  const [subjectError, setSubjectError] = useState("");

  const [subSubject, setSubSubject] = useState("");
  const [subSubjectError, setSubSubjectError] = useState("");

  const [subSubjectOptions, setSubSubjectOptions] = useState([]);
  const [subjectOptionsList, setSubjectOptionsList] = useState([]);

  const [regionOptionList, setRegionOptionList] = useState([]);
  const [region, setregion] = useState("");
  const [regionerror, setregionerror] = useState("");

  const [areaOptions, setAreaOptions] = useState([]);
  const [area, setArea] = useState("");
  const [areaError, setAreaError] = useState("");

  const educationLevelOption = [
    { value: "1094", label: "الابتدائية" },
    { value: "1095", label: "المتوسطة" },
    { value: "1096", label: "الثانوية" },
  ];

  const [educationLevel, seteducationLevel] = useState({ value: "", label: "" });
  const [educationLevelerror, seteducationLevelerror] = useState("");

  const [content, setcontent] = useState("");
  const [contenterror, setcontenterror] = useState("");

  const [error, seterror] = useState("");

  const [requesterName, setrequesterName] = useState("");
  const [requesterNameerror, setrequesterNameerror] = useState("");
  const [invoiceNumber, setinvoiceNumber] = useState("");
  const [invoiceNumbererror, setinvoiceNumbererror] = useState("");
  const [phoneNumber, setphoneNumber] = useState("");
  const [phoneNumbererror, setphoneNumbererror] = useState("");

  // حالة الإعاقة (اجباري الآن)
  const [disabledStatudList, setDisabledStatudList] = useState([]);
  const [disabledStatud, setdisabledStatud] = useState(null);
  const [disabledStatudError, setDisabledStatudError] = useState("");
  const [submitMessage, setSubmitMessage] = useState(""); // رسالة من السيرفر عند الفشل/التنبيه
  const [showNoorAlert, setShowNoorAlert] = useState(false);

  const isMounted = useIsMounted();

  // صفة المبلغ (required)
  const reporterOptions = [
    { value: "71",  label: "ولي أمر" },
    { value: "70",  label: "طالب/طالبة" },
    { value: "230", label: "مشرف/ـة نقل - مدرسة" },
  ];

  // Enhanced subject options with Noor system detection
  const enhancedSubjectOptions = subjectOptionsList.map(option => {
    if (option.label && option.label.includes('نور')) {
      return { ...option, isNoorRelated: true };
    }
    return option;
  });
  const [reporter, setReporter] = useState(null);
  const [reporterError, setReporterError] = useState("");

  // getSubjects
  useEffect(() => {
    const controller = new AbortController();
    axios
      .get(`https://csts.tatweertransit.com/support/ws/api/lookups/getSubjects`, { signal: controller.signal })
      .then((response) => {
        if (!isMounted.current) return;
        if (response?.status === 200) {
          let responseData = response?.data?.data ?? [];
          var toRemove = [208, 325, 432, 1561];
          let responseDataFormated = responseData.map((item) => ({ value: item.id, label: item.title }));
          var newresponseDataFormated = responseDataFormated.filter((item) => !toRemove.includes(item.value));
          setSubjectOptionsList(newresponseDataFormated);
        }
      })
      .catch(() => {})
      .finally(() => {});
    return () => controller.abort();
  }, []);

  // getRegions
  useEffect(() => {
    const controller = new AbortController();
    axios
      .get(`https://csts.tatweertransit.com/support/ws/api/lookups/getRegions`, { signal: controller.signal })
      .then((response) => {
        if (!isMounted.current) return;
        if (response?.status === 200) {
          let responseData = response?.data?.data ?? [];
          let responseDataFormated = responseData.map((item) => ({ value: item.id, label: item.title }));
          setRegionOptionList(responseDataFormated);
        }
      })
      .catch(() => {});
    return () => controller.abort();
  }, []);

  // getDisabledStatud
  useEffect(() => {
    const controller = new AbortController();
    axios
      .get(
        `https://csts.tatweertransit.com/support/ws/api/lookups/customFieldOptionsList?customfield_Id=${274}`,
        { signal: controller.signal }
      )
      .then((response) => {
        if (!isMounted.current) return;
        if (response?.status === 200) {
          let responseData = response?.data?.data ?? [];
          let responseDataFormated = responseData.map((item) => ({ value: item.id, label: item.title }));
          setDisabledStatudList(responseDataFormated);
        }
      })
      .catch(() => {});
    return () => controller.abort();
  }, []);

  // getAdministrations when region changes
  useEffect(() => {
    setAreaOptions([]);
    setArea("");
    if (!region?.value) return;
    const controller = new AbortController();
    axios
      .get(
        `https://csts.tatweertransit.com/support/ws/api/lookups/getAdministrations?region_id=${region.value}`,
        { signal: controller.signal }
      )
      .then((response) => {
        if (!isMounted.current) return;
        if (response?.status === 200) {
          let responseData = response?.data?.data ?? [];
          let responseDataFormated = responseData.map((item) => ({ value: item.id, label: item.title }));
          setAreaOptions(responseDataFormated);
        }
      })
      .catch(() => {});
    return () => controller.abort();
  }, [region]);

  // getSubsubjects when subject changes
  useEffect(() => {
    setSubSubjectOptions([]);
    setSubSubject("");
    if (!subject?.value) return;
    const controller = new AbortController();
    axios
      .get(
        `https://csts.tatweertransit.com/support/ws/api/lookups/getSubsubjects?subject_id=${subject.value}`,
        { signal: controller.signal }
      )
      .then((response) => {
        if (!isMounted.current) return;
        if (response?.status === 200) {
          let responseData = response?.data?.data ?? [];
          let responseDataFormated = responseData.map((item) => ({ value: item.id, label: item.title }));
          setSubSubjectOptions(responseDataFormated);
        }
      })
      .catch(() => {});
    return () => controller.abort();
  }, [subject]);

  const isSaudiIdValid = (idNumber) => {
    idNumber = (idNumber || "").replace(/\D/g, "");
    if (idNumber.length !== 10) return false;
    let sum = 0;
    let shouldDouble = true;
    for (let i = idNumber.length - 2; i >= 0; i--) {
      let digit = parseInt(idNumber.charAt(i));
      if (shouldDouble) {
        digit *= 2;
        if (digit > 9) digit -= 9;
      }
      sum += digit;
      shouldDouble = !shouldDouble;
    }
    const checkDigit = (10 - (sum % 10)) % 10;
    return checkDigit === parseInt(idNumber.charAt(9));
  };

  // ✅ كل الحقول إلزامية الآن
  const isFormValid = () => {
    let valid = true;

    if (!nId || nId.length < 10 || !isSaudiIdValid(nId)) {
      setnIderror("يرجى إدخال رقم هوية الطالب بشكل صحيح ");
      valid = false;
    } else setnIderror("");

    if (!studentName) {
      setstudentNameerror("يرجى إدخال اسم الطالب");
      valid = false;
    } else setstudentNameerror("");

    if (!phoneNumber || phoneNumber.length < 10) {
      setphoneNumbererror("يرجى إدخال رقم الجوال بشكل صحيح ");
      valid = false;
    } else setphoneNumbererror("");

    if (!reporter) {
      setReporterError("يرجى اختيار صفة المُبلِّغ");
      valid = false;
    } else {
      setReporterError("");
    }

    if (!disabledStatud) {
      setDisabledStatudError("يرجى اختيار حالة الإعاقة");
      valid = false;
    } else setDisabledStatudError("");

    if (!region) {
      setregionerror("يرجى إدخال المنطقة");
      valid = false;
    } else setregionerror("");

    if (!area) {
      setAreaError("يرجى إدخال الإدارة التعليمية");
      valid = false;
    } else setAreaError("");

    if (!schoolName) {
      setschoolNameerror("يرجى إدخال اسم المدرسة");
      valid = false;
    } else setschoolNameerror("");

    if (!educationLevel || !educationLevel.value) {
      seteducationLevelerror("يرجى إدخال المرحلة الدراسية");
      valid = false;
    } else seteducationLevelerror("");

    if (!subject) {
      setSubjectError("يرجى إدخال عنوان الشكوى");
      valid = false;
    } else setSubjectError("");

    if (!subSubject) {
      setSubSubjectError("يرجى إدخال مسار الشكوى");
      valid = false;
    } else setSubSubjectError("");

    if (!content) {
      setcontenterror("يرجى إدخال الرسالة");
      valid = false;
    } else setcontenterror("");

    return valid;
  };

  return (
    <>
      <Section>
        <ServiceTransferBanner />
        <SectionTitle>تقديم بلاغ جديد</SectionTitle>

        <NoteCard role="alert" aria-live="polite">
          عزيزي المستفيد، نأمل التأكد من صحة جميع البيانات واختيار العنوان
          والمسار المناسبين لتسريع معالجة البلاغ.
        </NoteCard>
        
        <NoteCard className="secondary" role="note" aria-live="polite">
          ملاحظة ,نود افادتكم فيما يخص المشاكل التقنية التي قد تواجهكم في نظام نور يرجى التكرم برفع البلاغ عن طريق ايقونة الدعم الفني في نظام نور.
        </NoteCard>

        <Card as="form" onSubmit={(e) => e.preventDefault()} style={{ pointerEvents: 'none', opacity: 0.6 }}>
          <FormGrid>
            <FormSection>
              <SectionHeader>معلومات الطالب</SectionHeader>
              <FieldGroup>
                <Field>
                  <Label htmlFor="nId" className="required">رقم هوية الطالب</Label>
                  <Input
                    required
                    id="nId"
                    type="text"
                    inputMode="numeric"
                    maxLength={10}
                    value={nId}
                    aria-invalid={!!nIderror}
                    aria-describedby="nIdHelp nIdErr"
                    placeholder="أدخل رقم الهوية المكون من 10 أرقام"
                    onChange={(e) => {
                      const v = e.target.value.slice(0, 10);
                      setnId(v);
                      if (!v || v.length < 10 || !isSaudiIdValid(v)) {
                        setnIderror("يرجى إدخال رقم هوية الطالب بشكل صحيح ");
                      } else {
                        setnIderror("");
                      }
                    }}
                  />
                  <FieldHelper id="nIdHelp">الرقم المكون من 10 أرقام في بطاقة الطالب</FieldHelper>
                  {nIderror && <Error id="nIdErr">{nIderror}</Error>}
                </Field>

                <Field>
                  <Label htmlFor="studentName" className="required">اسم الطالب</Label>
                  <Input
                    id="studentName"
                    required
                    type="text"
                    value={studentName}
                    placeholder="أدخل الاسم الكامل للطالب"
                    aria-invalid={!!studentNameerror}
                    onChange={(e) => {
                      const v = e.target.value;
                      setstudentName(v);
                      setstudentNameerror(v ? "" : "يرجى إدخال اسم الطالب");
                    }}
                  />
                  {studentNameerror && <Error>{studentNameerror}</Error>}
                </Field>

              </FieldGroup>
            </FormSection>

            <FormSection>
              <SectionHeader>معلومات مُقَدِّم البلاغ</SectionHeader>
              <FieldGroup>
                <Field>
                  <Label htmlFor="reporter" className="required">صفة المُبلِّغ</Label>
                  <SelectStyled
                    inputId="reporter"
                    classNamePrefix="rs"
                    value={reporter}
                    options={reporterOptions}
                    placeholder="اختر علاقتك بالطالب"
                    onChange={(e) => {
                      setReporter(e);
                      setReporterError(e ? "" : "يرجى اختيار صفة المُبلِّغ");
                    }}
                  />
                  {reporterError && <Error>{reporterError}</Error>}
                </Field>

                <Field>
                  <Label htmlFor="phoneNumber" className="required">رقم الجوال</Label>
                  <Input
                    id="phoneNumber"
                    required
                    type="text"
                    inputMode="tel"
                    maxLength={10}
                    value={phoneNumber}
                    placeholder="05xxxxxxxx"
                    aria-invalid={!!phoneNumbererror}
                    onChange={(e) => {
                      const v = e.target.value.slice(0, 10);
                      setphoneNumber(v);
                      setphoneNumbererror(v.length < 10 ? "يرجى إدخال رقم الجوال بشكل صحيح " : "");
                    }}
                  />
                  <FieldHelper>سيتم استخدامه للتواصل معكم بخصوص البلاغ</FieldHelper>
                  {phoneNumbererror && <Error>{phoneNumbererror}</Error>}
                </Field>
              </FieldGroup>
            </FormSection>

            <FormSection>
              <SectionHeader>معلومات المدرسة والموقع</SectionHeader>
              <FieldGroup>

                <Field>
                  <Label htmlFor="disabledStatud" className="required">حالة الإعاقة</Label>
                  <SelectStyled
                    inputId="disabledStatud"
                    classNamePrefix="rs"
                    value={disabledStatud}
                    options={disabledStatudList}
                    placeholder="اختر حالة الإعاقة"
                    onChange={(e) => {
                      setdisabledStatud(e);
                      setDisabledStatudError(e ? "" : "يرجى اختيار حالة الإعاقة");
                    }}
                  />
                  {disabledStatudError && <Error>{disabledStatudError}</Error>}
                </Field>

                <Field>
                  <Label htmlFor="region" className="required">المنطقة</Label>
                  <SelectStyled
                    inputId="region"
                    classNamePrefix="rs"
                    value={region}
                    options={regionOptionList}
                    placeholder="اختر المنطقة"
                    onChange={(e) => {
                      setregion(e);
                      setregionerror(e ? "" : "يرجى إدخال المنطقة");
                    }}
                  />
                  {regionerror && <Error>{regionerror}</Error>}
                </Field>

                <Field>
                  <Label htmlFor="administration" className="required">الإدارة التعليمية</Label>
                  <SelectStyled
                    inputId="administration"
                    classNamePrefix="rs"
                    value={area}
                    options={areaOptions}
                    placeholder={region ? "اختر الإدارة التعليمية" : "اختر المنطقة أولاً"}
                    isDisabled={!region}
                    onChange={(e) => {
                      setArea(e);
                      setAreaError(e ? "" : "يرجى إدخال الإدارة التعليمية");
                    }}
                  />
                  {areaError && <Error>{areaError}</Error>}
                </Field>

                <Field>
                  <Label htmlFor="schoolName" className="required">اسم المدرسة</Label>
                  <Input
                    id="schoolName"
                    required
                    type="text"
                    value={schoolName}
                    placeholder="أدخل اسم المدرسة كاملاً"
                    onChange={(e) => {
                      const v = e.target.value;
                      setschoolName(v);
                      setschoolNameerror(v ? "" : "يرجى إدخال اسم المدرسة");
                    }}
                  />
                  <FieldHelper>تأكد من كتابة اسم المدرسة بشكل صحيح</FieldHelper>
                  {schoolNameerror && <Error>{schoolNameerror}</Error>}
                </Field>

                <Field>
                  <Label htmlFor="educationLevel" className="required">المرحلة الدراسية</Label>
                  <SelectStyled
                    inputId="educationLevel"
                    classNamePrefix="rs"
                    value={educationLevel}
                    options={educationLevelOption}
                    placeholder="اختر المرحلة الدراسية"
                    onChange={(e) => {
                      seteducationLevel(e);
                      seteducationLevelerror(e ? "" : "يرجى إدخال المرحلة الدراسية");
                    }}
                  />
                  {educationLevelerror && <Error>{educationLevelerror}</Error>}
                </Field>
              </FieldGroup>
            </FormSection>

            <FormSection>
              <SectionHeader>تفاصيل البلاغ</SectionHeader>
              <FieldGroup>

                <Field>
                  <Label htmlFor="subject" className="required">عنوان الشكوى</Label>
                  <SelectStyled
                    inputId="subject"
                    classNamePrefix="rs"
                    value={subject}
                    options={enhancedSubjectOptions}
                    placeholder="اختر نوع الشكوى"
                    onChange={(e) => {
                      setsubject(e);
                      setSubjectError(e ? "" : "يرجى إدخال عنوان الشكوى");
                      // Show Noor alert if Noor-related subject is selected
                      setShowNoorAlert(e && e.isNoorRelated);
                    }}
                  />
                  {subjectError && <Error>{subjectError}</Error>}
                  
                  {showNoorAlert && (
                    <ConditionalAlert>
                      <p>
                        للحصول على أسرع حل، يرجى تقديم هذا النوع من المشاكل مباشرة عبر أيقونة "الدعم الفني" في نظام نور.
                        <br />
                        <a href="#" target="_blank" rel="noopener noreferrer">
                          الانتقال إلى نظام نور
                        </a>
                      </p>
                    </ConditionalAlert>
                  )}
                </Field>

                <Field>
                  <Label htmlFor="subSubject" className="required">مسار الشكوى</Label>
                  <SelectStyled
                    inputId="subSubject"
                    classNamePrefix="rs"
                    value={subSubject}
                    options={subSubjectOptions}
                    placeholder={subject ? "اختر مسار الشكوى" : "اختر عنوان الشكوى أولاً"}
                    isDisabled={!subject}
                    onChange={(e) => {
                      setSubSubject(e);
                      setSubSubjectError(e ? "" : "يرجى إدخال مسار الشكوى");
                    }}
                  />
                  {subSubjectError && <Error>{subSubjectError}</Error>}
                </Field>

                <Field>
                  <Label htmlFor="invoiceNumber">رقم الفاتورة (اختياري)</Label>
                  <Input
                    id="invoiceNumber"
                    type="text"
                    inputMode="numeric"
                    value={invoiceNumber}
                    placeholder="أدخل رقم الفاتورة إن وجد"
                    onChange={(e) => {
                      const v = e.target.value;
                      setinvoiceNumber(v);
                    }}
                  />
                  <FieldHelper>اتركه فارغاً إذا لم يكن متوفراً</FieldHelper>
                </Field>
              </FieldGroup>

              <Field fullWidth>
                <Label htmlFor="content" className="required">تفاصيل الشكوى</Label>
                <Textarea
                  id="content"
                  required
                  value={content}
                  placeholder="اشرح تفاصيل الشكوى بوضوح..."
                  aria-invalid={!!contenterror}
                  aria-describedby="contentErr"
                  onChange={(e) => {
                    const v = e.target.value;
                    setcontent(v);
                    setcontenterror(v ? "" : "يرجى إدخال الرسالة");
                  }}
                />
                <FieldHelper>اكتب وصفاً مفصلاً للمشكلة لمساعدتنا في حلها بسرعة</FieldHelper>
                {contenterror && <Error id="contentErr">{contenterror}</Error>}
              </Field>
            </FormSection>

          </FormGrid>

          <Actions>
            <PrimaryButton
              type="button"
              aria-busy={false}
              disabled={true}
              onClick={(e) => {
                e.preventDefault();
                return false;
              }}
              style={{ opacity: 0.5, cursor: 'not-allowed' }}
            >
              الخدمة غير متاحة
            </PrimaryButton>
            {error && <FormError role="alert">{error}</FormError>}
          </Actions>
        </Card>
      </Section>

      {docData?.login && docData?.valid && (
        <Section>
          <Card>
            <SectionTitle as="h2">تأكيد إرسال البلاغ</SectionTitle>
            {!showPDF && (
              <>
                <Banner ok>
                  <h3>
                    عزيزي ولي أمر الطالب رقم هوية {nId} – واسمه {studentName}.
                    للتأكيد على رفع بلاغ جديد اضغط الزر أدناه.
                  </h3>
                </Banner>

                <PrimaryButton
                  type="button"
                  disabled={true}
                  aria-busy={false}
                  onClick={(e) => {
                    e.preventDefault();
                    return false;
                  }}
                  style={{ opacity: 0.5, cursor: 'not-allowed' }}
                >
                  الخدمة غير متاحة
                </PrimaryButton>
              </>
            )}

            {showPDF && (
              <>
                {processStatus ? (
                  <ConfirmationCard>
                    <ProcessSuccessContainer>
                      تم استلام بلاغكم بنجاح!
                    </ProcessSuccessContainer>
                    <div className="reference-number">
                      رقم البلاغ: #{requestId}
                    </div>
                    <div className="summary">
                      <h4>ملخص البلاغ المُرسل</h4>
                      <div className="summary-item">
                        <span className="label">اسم الطالب:</span>
                        <span className="value">{studentName}</span>
                      </div>
                      <div className="summary-item">
                        <span className="label">رقم الهوية:</span>
                        <span className="value">{nId}</span>
                      </div>
                      <div className="summary-item">
                        <span className="label">رقم الجوال:</span>
                        <span className="value">{phoneNumber}</span>
                      </div>
                      <div className="summary-item">
                        <span className="label">عنوان الشكوى:</span>
                        <span className="value">{subject?.label}</span>
                      </div>
                      <div className="summary-item">
                        <span className="label">تاريخ الإرسال:</span>
                        <span className="value">{new Date().toLocaleDateString('ar-SA')}</span>
                      </div>
                    </div>
                    <p style={{marginTop: '20px', color: 'var(--muted)'}}>
                      سيتم التواصل معكم على رقم الجوال المُسجل خلال 24-48 ساعة
                    </p>
                  </ConfirmationCard>
                ) : (
                  <ProcessFailedContainer>
                    {submitMessage || "تعذر إتمام الطلب."}
                  </ProcessFailedContainer>
                )}
              </>
            )}
          </Card>
        </Section>
      )}

      {docData?.login && !docData?.valid && (
        <Section>
          <Card>
            <SectionTitle as="h2">تقديم بلاغ جديد</SectionTitle>
            <Banner>
              <h3>لم يتم رفع طلب الإلغاء لأحد الأسباب التالية:</h3>
              <ul>
                <li>تم رفع طلب سابق وجاري التعامل معه</li>
                <li>رقم الجوال أو رقم الهوية غير صحيح</li>
                <li>أحد البيانات المدخلة ناقصة</li>
              </ul>
              <p>
                في حالة استمرار الرفض نأمل التواصل على الرقم المجاني الموضح
                أدناه.
              </p>
            </Banner>
          </Card>
        </Section>
      )}
    </>
  );
};

export default SubmitComplaint;
